import React from "react";
import ColumnItem from "../ColumnItem/ColumnItem";
import { fixedHTML } from "../../utils";
import "./columnsItem.less";

const ColumnsItem = ({ rows, columns, restOfColumns, showTitle }) => {
   return (
      <div className="gx-product-body-columns">
         {columns.map((col) => {
            if (restOfColumns.find((rest) => col.title === rest))
               return (
                  <ColumnItem
                     key={col.techName}
                     showTitle={showTitle}
                     title={col.title}
                     row={fixedHTML(rows[col.title])}
                  />
               );
         })}
      </div>
   );
};

export default ColumnsItem;
